import {inject, Service} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {finalize, Observable} from 'rxjs';
import {BillingSchemeModel} from '../models/billing-scheme.model';
import {share} from 'rxjs/operators';

@Service()
export class BillingSchemeService {
  private http = inject(HttpClient);

  private schemesObservable: Observable<BillingSchemeModel[]> | null = null;

  fetch(): Observable<Array<BillingSchemeModel>> {
    if (!this.schemesObservable) {
      this.schemesObservable = this.http
        .get<BillingSchemeModel[]>('/api/billing-schemes')
        .pipe(
          share(),
          finalize(() => this.schemesObservable = null),
        );
    }

    return this.schemesObservable;
  }
}
